import React, { memo } from 'react';
import { styled } from '@compiled/react';
import { SkeletonItem } from '@atlaskit/menu';

const DialogContentFallback = (): React.JSX.Element => (
	<FallbackWrapper>
		<SkeletonItem width="100%" testId="up-flow-touchpoint.ui.dialog-content.fallback.full-width" />
		<SkeletonItem
			width="62.5%"
			testId="up-flow-touchpoint.ui.dialog-content.fallback.medium-width"
		/>
	</FallbackWrapper>
);

export default memo(DialogContentFallback);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const FallbackWrapper = styled.div({
	width: '208px',
});
